import { useQuery, useMutation } from 'react-query';

import { requestNewInsuredF5 } from '../services/team5';
import { RequestNewInsured } from '../types/teamf5';

import { getCurrentTeamF5, getDataRankingF5 } from '@/services/team5';

export const useGetCurrentTeamF5 = (
  tieneEquipoF5: boolean | undefined,
  options?: { enabled?: boolean }
) => {
  return useQuery('useGetCurrentTeamF5', async () => await getCurrentTeamF5(), {
    refetchOnWindowFocus: false,
    keepPreviousData: false,
    enabled: !!tieneEquipoF5 && (options?.enabled ?? true),
  });
};

export const usePostDataRanking = () => {
  return useMutation(async (date: string) => await getDataRankingF5(date));
};

export const useRequestNewInsured = () => {
  return useMutation(
    async (data: RequestNewInsured) => await requestNewInsuredF5(data)
  );
};
